import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import asyncComponent from './asyncComponent';
// import Activity from "../pages/Activity/Activity";
// import PayPage from "../pages/PayPage/PayPage";

const Activity = asyncComponent(() => import("../pages/Activity/Activity"));
const PayPage = asyncComponent(() => import("../pages/PayPage/PayPage"));
const Routes = () => {
  const nowLogin = sessionStorage.getItem("nowLogin");
  return (
    <div>
      <Switch>
        <Route exact path="/" component={Activity} />
        <Route exact path="/pay" component={PayPage} />
        <Redirect to="/" />
      </Switch>
    </div>
  )
};
export default Routes;
